<nb-card>
	<nb-card-header>
		<h4>{{ 'HELP_PAGE.HELP' | translate }}</h4>
	</nb-card-header>
	<nb-card-body> </nb-card-body>
</nb-card>
